import type { Translations } from '../i18n';

type T = Translations;

/** #642 — the label of the computed novice status of a pool member, or null
 *  when the member is experienced in both seats. The server computes the
 *  status for each seat (backend lib/officialProfile.ts). */
export function noviceLabel(r: { novice_side_judge?: boolean; novice_ring_referee?: boolean }, t: T): string | null {
  const side = !!r.novice_side_judge;
  const ring = !!r.novice_ring_referee;
  if (side && ring) return t.refereeModal.novice;
  if (ring) return t.refereeModal.noviceRingReferee;
  if (side) return t.refereeModal.noviceSideJudge;
  return null;
}

/** #642 — the seats in which a pool member is a novice, as the value of the
 *  "Novice" line of the referee window. */
export function noviceSeats(r: { novice_side_judge?: boolean; novice_ring_referee?: boolean }, t: T): string {
  const side = !!r.novice_side_judge;
  const ring = !!r.novice_ring_referee;
  if (side && ring) return t.refereeModal.noviceSeatsBoth;
  if (ring) return t.refereeModal.noviceSeatsRing;
  if (side) return t.refereeModal.noviceSeatsSide;
  return t.refereeModal.noviceNone;
}
